import React from 'react';
import { Link } from 'react-router-dom';
import { TwitterIcon, GithubIcon, HomeIcon, PlusCircleIcon, LayoutGridIcon as AppsIcon } from 'lucide-react';
export const Footer = () => {
  return <>
      {/* Desktop Footer */}
      <footer className="bg-white border-t border-gray-200 py-8 hidden md:block" data-id="element-108">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-109">
          <div data-id="element-110">
            <h3 className="font-medium text-gray-800 mb-4" data-id="element-111">Company</h3>
            <ul className="space-y-2" data-id="element-112">
              <li data-id="element-113">
                <Link to="/about" className="text-gray-600 hover:text-indigo-600" data-id="element-114">
                  About
                </Link>
              </li>
              <li data-id="element-115">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-116">
                  Careers
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-117">
            <h3 className="font-medium text-gray-800 mb-4" data-id="element-118">Resources</h3>
            <ul className="space-y-2" data-id="element-119">
              <li data-id="element-120">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-121">
                  Documentation
                </a>
              </li>
              <li data-id="element-122">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-123">
                  Help Center
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-124">
            <h3 className="font-medium text-gray-800 mb-4" data-id="element-125">Legal</h3>
            <ul className="space-y-2" data-id="element-126">
              <li className="flex space-x-4" data-id="element-127">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-128">
                  Privacy
                </a>
                <span className="text-gray-300" data-id="element-129">|</span>
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-130">
                  Terms
                </a>
              </li>
              <li data-id="element-131">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-132">
                  Security
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-133">
            <h3 className="font-medium text-gray-800 mb-4" data-id="element-134">Connect</h3>
            <div className="flex space-x-4" data-id="element-135">
              <a href="#" className="text-gray-500 hover:text-indigo-600" data-id="element-136">
                <TwitterIcon className="h-5 w-5" data-id="element-137" />
              </a>
              <a href="#" className="text-gray-500 hover:text-indigo-600" data-id="element-138">
                <GithubIcon className="h-5 w-5" data-id="element-139" />
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* Mobile Navigation Bar */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2" data-id="element-140">
        <div className="flex justify-around items-center" data-id="element-141">
          <Link to="/" className="flex flex-col items-center p-2" data-id="element-142">
            <HomeIcon className="h-6 w-6 text-gray-500" data-id="element-143" />
            <span className="text-xs text-gray-500" data-id="element-144">Discover</span>
          </Link>
          <Link to="/my-apps" className="flex flex-col items-center p-2" data-id="element-145">
            <AppsIcon className="h-6 w-6 text-gray-500" data-id="element-146" />
            <span className="text-xs text-gray-500" data-id="element-147">My Apps</span>
          </Link>
          <Link to="/create" className="flex flex-col items-center p-2" data-id="element-148">
            <PlusCircleIcon className="h-6 w-6 text-gray-500" data-id="element-149" />
            <span className="text-xs text-gray-500" data-id="element-150">Create</span>
          </Link>
        </div>
      </nav>
    </>;
};